import { Injectable } from '@angular/core';
import { Avatar, BodyType, Sprite, SpriteType } from '@libs/models/avatar.model';

type ItemAvailabilityRule = {
  name: string;
  enabled: boolean;
  type?: SpriteType | string;
  body?: BodyType;
  colorName?: string;
};

const MOCK_SPRITES = [
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    type: SpriteType.SKIN,
    name: 'Tom de pele',
    items: [
      { colorName: 'Branco', color: '#F5D6C6', urlSprite: '/assets/avatar_mock/2SV_CORPO_BRANCO.png' },
      { colorName: 'Pardo', color: '#E1AC88', urlSprite: '/assets/avatar_mock/2SV_CORPO_PARDO.png' },
      { colorName: 'Moreno', color: '#996A4A', urlSprite: '/assets/avatar_mock/2SV_CORPO_MORENO.png' },
    ]
  },
  {
    body: [BodyType.MALE],
    name: 'Cabelo 1',
    type: SpriteType.HAIR,
    items: [
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_CABELO1-PRETO.png' },
      { colorName: 'Castanho', color: '#8B4513', urlSprite: '/assets/avatar_mock/2SV_CABELO1-CASTANHO.png' },
      { colorName: 'Loiro', color: '#FFD700', urlSprite: '/assets/avatar_mock/2SV_CABELO1-LOIRO.png' },
      { colorName: 'Ruivo', color: '#FF4500', urlSprite: '/assets/avatar_mock/2SV_CABELO1-RUIVO.png' },
    ]
  },
  {
    body: [BodyType.MALE],
    name: 'Cabelo 2',
    type: SpriteType.HAIR,
    items: [
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_CABELO2-PRETO.png' },
      { colorName: 'Castanho', color: '#8B4513', urlSprite: '/assets/avatar_mock/2SV_CABELO2-CASTANHO.png' },
      { colorName: 'Loiro', color: '#FFD700', urlSprite: '/assets/avatar_mock/2SV_CABELO2-LOIRO.png' },
      { colorName: 'Ruivo', color: '#FF4500', urlSprite: '/assets/avatar_mock/2SV_CABELO2-RUIVO.png' },
    ]
  },
  {
    body: [BodyType.MALE],
    name: 'Cabelo 3',
    type: SpriteType.HAIR,
    items: [
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_CABELO3-PRETO.png' },
      { colorName: 'Castanho', color: '#8B4513', urlSprite: '/assets/avatar_mock/2SV_CABELO3-CASTANHO.png' },
      { colorName: 'Loiro', color: '#FFD700', urlSprite: '/assets/avatar_mock/2SV_CABELO3-LOIRO.png' },
      { colorName: 'Ruivo', color: '#FF4500', urlSprite: '/assets/avatar_mock/2SV_CABELO3-RUIVO.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Cabelo black',
    type: SpriteType.HAIR,
    items: [
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_CABELOBLACK-PRETO.png' },
      { colorName: 'Castanho', color: '#8B4513', urlSprite: '/assets/avatar_mock/2SV_CABELOBLACK-CASTANHO.png' },
      { colorName: 'Loiro', color: '#FFD700', urlSprite: '/assets/avatar_mock/2SV_CABELOBLACK-LOIRO.png' },
      { colorName: 'Ruivo', color: '#FF4500', urlSprite: '/assets/avatar_mock/2SV_CABELOBLACK-RUIVO.png' },
    ]
  },
  {
    body: [BodyType.FEMALE],
    name: 'Cabelo 1',
    type: SpriteType.HAIR,
    items: [
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_CABELO1-F-PRETO.png' },
      { colorName: 'Castanho', color: '#8B4513', urlSprite: '/assets/avatar_mock/2SV_CABELO1-F-CASTANHO.png' },
      { colorName: 'Loiro', color: '#FFD700', urlSprite: '/assets/avatar_mock/2SV_CABELO1-F-LOIRO.png' },
      { colorName: 'Ruivo', color: '#FF4500', urlSprite: '/assets/avatar_mock/2SV_CABELO1-F-RUIVO.png' },
    ]
  },
  {
    body: [BodyType.FEMALE],
    name: 'Cabelo 2',
    type: SpriteType.HAIR,
    items: [
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_CABELO2-F-PRETO.png' },
      { colorName: 'Castanho', color: '#8B4513', urlSprite: '/assets/avatar_mock/2SV_CABELO2-F-CASTANHO.png' },
      { colorName: 'Loiro', color: '#FFD700', urlSprite: '/assets/avatar_mock/2SV_CABELO2-F-LOIRO.png' },
      { colorName: 'Ruivo', color: '#FF4500', urlSprite: '/assets/avatar_mock/2SV_CABELO2-F-RUIVO.png' },
    ]
  },
  {
    body: [BodyType.FEMALE],
    name: 'Cabelo 3',
    type: SpriteType.HAIR,
    items: [
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_CABELO3-F-PRETO.png' },
      { colorName: 'Castanho', color: '#8B4513', urlSprite: '/assets/avatar_mock/2SV_CABELO3-F-CASTANHO.png' },
      { colorName: 'Loiro', color: '#FFD700', urlSprite: '/assets/avatar_mock/2SV_CABELO3-F-LOIRO.png' },
      { colorName: 'Ruivo', color: '#FF4500', urlSprite: '/assets/avatar_mock/2SV_CABELO3-F-RUIVO.png' },
    ]
  },
  {
    body: [BodyType.MALE],
    name: 'Polo',
    type: SpriteType.SHIRT,
    items: [
      { colorName: 'Branco', color: '#FFFFFF', urlSprite: '/assets/avatar_mock/2SV_POLO-M-BRANCA.png' },
      { colorName: 'Azul', color: '#0000FF', urlSprite: '/assets/avatar_mock/2SV_POLO-M-AZUL.png' },
      { colorName: 'Verde', color: '#008000', urlSprite: '/assets/avatar_mock/2SV_POLO-M-VERDE.png' },
      { colorName: 'Amarelo', color: '#FFFF00', urlSprite: '/assets/avatar_mock/2SV_POLO-M-AMARELA.png' },
      { colorName: 'Vermelho', color: '#FF0000', urlSprite: '/assets/avatar_mock/2SV_POLO-M-VERMELHA.png' },
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_POLO-M-PRETA.png' },
      { colorName: 'Roxo', color: '#800080', urlSprite: '/assets/avatar_mock/2SV_POLO-M-ROXO.png' },
      { colorName: 'Laranja', color: '#FFA500', urlSprite: '/assets/avatar_mock/2SV_POLO-M-LARANJA.png' },
    ]
  },
  {
    body: [BodyType.MALE],
    name: 'Camisa 2SV',
    type: SpriteType.SHIRT,
    items: [
      { colorName: 'Azul', color: '#273C9E', urlSprite: '/assets/avatar_mock/2SV_CAMISA-2SV.png' },
    ]
  },
  {
    body: [BodyType.MALE],
    name: 'Camisa time',
    type: SpriteType.SHIRT,
    items: [
      { colorName: 'Branco', color: '#FFFFFF', urlSprite: '/assets/avatar_mock/2SV_CAMISA-TIME-BRANCA.png' },
    ]
  },
  {
    body: [BodyType.FEMALE],
    name: 'Polo',
    type: SpriteType.SHIRT,
    items: [
      { colorName: 'Branco', color: '#FFFFFF', urlSprite: '/assets/avatar_mock/2SV_POLO-F-BRANCA.png' },
      { colorName: 'Azul', color: '#0000FF', urlSprite: '/assets/avatar_mock/2SV_POLO-F-AZUL.png' },
      { colorName: 'Verde', color: '#008000', urlSprite: '/assets/avatar_mock/2SV_POLO-F-VERDE.png' },
      { colorName: 'Amarelo', color: '#FFFF00', urlSprite: '/assets/avatar_mock/2SV_POLO-F-AMARELO.png' },
      { colorName: 'Vermelho', color: '#FF0000', urlSprite: '/assets/avatar_mock/2SV_POLO-F-VERMELHO.png' },
      { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_POLO-F-PRETA.png' },
      { colorName: 'Roxo', color: '#800080', urlSprite: '/assets/avatar_mock/2SV_POLO-F-ROXO.png' },
      { colorName: 'Laranja', color: '#FFA500', urlSprite: '/assets/avatar_mock/2SV_POLO-F-LARANJA.png' },
    ]
  },
  {
    body: [BodyType.FEMALE],
    name: 'Camisa 2SV',
    type: SpriteType.SHIRT,
    items: [
      { colorName: 'Azul', color: '#273C9E', urlSprite: '/assets/avatar_mock/2SV_CAMISA-F-2SV.png' },
    ]
  },
  {
    body: [BodyType.FEMALE],
    name: 'Camisa time',
    type: SpriteType.SHIRT,
    items: [
      { colorName: 'Azul', color: '#273C9E', urlSprite: '/assets/avatar_mock/2SV_CAMISA-F-TIME.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Shorts',
    type: SpriteType.PANTS,
    items: [
      { colorName: 'Preto', color: '#1F1F1F', urlSprite: '/assets/avatar_mock/2SV_SHORTS-PRETO.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Calça',
    type: SpriteType.PANTS,
    items: [
      { colorName: 'Azul', color: '#0000FF', urlSprite: '/assets/avatar_mock/2SV_CALÇA-AZUL.png' },
      { colorName: 'Marrom', color: '#8B4513', urlSprite: '/assets/avatar_mock/2SV_CALÇA-MARROM.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Tênis',
    type: SpriteType.SHOES,
    items: [
      { colorName: 'Preto', color: '#1F1F1F', urlSprite: '/assets/avatar_mock/2SV_TENIS-PRETO.png' },
      { colorName: 'Branco', color: '#FFFFFF', urlSprite: '/assets/avatar_mock/2SV_TENIS-BRANCO.png' },
      { colorName: 'Vermelho', color: '#FF0000', urlSprite: '/assets/avatar_mock/2SV_TENIS-VERMELHO.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Chuteira',
    type: SpriteType.SHOES,
    items: [
      { colorName: 'Preto', color: '#1F1F1F', urlSprite: '/assets/avatar_mock/2SV_CHUTEIRA.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Chapeu',
    type: SpriteType.HAT,
    items: [
      { colorName: 'Nenhum', color: 'transparent' },
      { colorName: 'Azul', color: '#273C9E', urlSprite: '/assets/avatar_mock/2SV_CAPELO.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Acessorio',
    type: SpriteType.ACCESSORY,
    items: [
      { colorName: 'Nenhum', color: 'transparent' },
      { colorName: 'Azul', color: '#273C9E', urlSprite: '/assets/avatar_mock/2SV_CANUDO.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Mochila',
    type: SpriteType.BAG,
    items: [
      { colorName: 'Nenhum', color: 'transparent' },
      { colorName: 'Azul', color: '#273C9E', urlSprite: '/assets/avatar_mock/2SV_MOCHILA.png' },
      { colorName: 'Vermelho', color: '#B83B3B', urlSprite: '/assets/avatar_mock/2SV_MALA.png' },
    ]
  },
  {
    body: [BodyType.MALE, BodyType.FEMALE],
    name: 'Bola',
    type: SpriteType.BALL,
    items: [
      { colorName: 'Nenhum', color: 'transparent' },
      { colorName: 'Branco', color: '#FFFFFF', urlSprite: '/assets/avatar_mock/2SV_BOLA-BRANCA.png' },
      { colorName: 'Preto', color: '#1F1F1F', urlSprite: '/assets/avatar_mock/2SV_BOLA-PRETA.png' },
    ]
  }
]

@Injectable({
  providedIn: 'root'
})
export class AvatarService {

  loadAll() {
    return MOCK_SPRITES;
  }

  filterSprite(sprites: Sprite[], body: BodyType, type: SpriteType): Sprite[] {
    return sprites.filter(s => s.body?.includes(body) && s.type === type);
  }

  applyItemAvailability(
    sprites: Sprite[],
    rules: ItemAvailabilityRule[]
  ): Sprite[] {
    return sprites
      .filter((sprite) => {
        const rule = rules.find((item) =>
          !item.colorName &&
          this.matchAvailabilityRule(sprite, item)
        );

        return rule?.enabled ?? true;
      })
      .map((sprite) => {
        const colorRules = rules.filter((item) =>
          item.colorName &&
          this.matchAvailabilityRule(sprite, item)
        );

        if (!colorRules.length) return sprite;

        return {
          ...sprite,
          items: sprite.items?.filter((spriteItem) => {
            const rule = colorRules.find((item) => item.colorName === spriteItem.colorName);
            return rule?.enabled ?? true;
          })
        };
      });
  }

  private matchAvailabilityRule(sprite: Sprite, rule: ItemAvailabilityRule): boolean {
    return rule.name === sprite.name &&
      (!rule.type || rule.type === sprite.type) &&
      (!rule.body || !!sprite.body?.includes(rule.body));
  }

  getAvatarDefault(): Avatar {
    return {
      body: BodyType.MALE,
      skin: { colorName: 'Branco', color: '#F5D6C6', urlSprite: '/assets/avatar_mock/2SV_CORPO_BRANCO.png' },
      hair: { colorName: 'Preto', color: '#000000', urlSprite: '/assets/avatar_mock/2SV_CABELO1-PRETO.png' },
      shirt: { colorName: 'Branco', color: '#FFFFFF', urlSprite: '/assets/avatar_mock/2SV_POLO-M-BRANCA.png' },
      pants: { colorName: 'Preto', color: '#1F1F1F', urlSprite: '/assets/avatar_mock/2SV_SHORTS-PRETO.png' },
      shoes: { colorName: 'Preto', color: '#1F1F1F', urlSprite: '/assets/avatar_mock/2SV_TENIS-PRETO.png' },
    }
  }
}
